import Vue from "vue";
import Router from "vue-router";
import ForestParFr from "./views/ForestParFr";
import ForestParEn from "./views/ForestParEn";

import Signup from "./views/Signup";
import Signin from "./views/Signin";
import Index from "./views/Index";
import Cedeflaw from "./views/Cedeflaw";
import mcico from "./views/mcico";
import proliteracty from "./views/Proliteracy";
import Vetvine from "./views/Vetvine";
import Cybersafe from "./views/Cybersafe";
import Transportation from "./views/Transportation";
import ForestRSG from "./views/ForestRSG";
import Gribb1 from "./views/Gribb1";
import Truman from "./views/Truman";
import Vlad1 from "./views/Vlad1";
import Demo from "./views/Demo";
import Feng from "./views/Feng";
import Ffre from "./views/Ffre";
import Forp1 from "./views/Forp1";
import Forp2 from "./views/Forp2";
import LegalWiseJuneNZ from "./views/LegalWiseJuneNZ";
import LegalWiseJuneAUS from "./views/LegalWiseJuneAUS";
import Tmg1 from "./views/Tmg1";
import Cuservices from "./views/Cuservices";
import Ceu2 from "./views/Ceu2";
import Authenticated from "./views/Authenticated";
import store from "./store";
import Crown1 from "./views/Crown1";
import Crown2 from "./views/Crown2";
import UKY1 from "./views/UKY1";
import Concussion1 from "./views/Concussion1";
import Advantage from "./views/Forest1";
import Wellbeing1 from "./views/Wellbeing1";
import ForestMar25 from "./views/ForestMar25";
import ForestersEstate from "./views/ForestersEstate";
import ForestBetter from "./views/ForestBetter";
import ForestOpportunity from "./views/ForestOpportunity";
import ForestersSalesEN from "./views/ForestersSalesEN";
import ForestersSalesFR from "./views/ForestersSalesFR";
import ForestVision2020French from "./views/ForestVision2020French";
import ForestVision2020English from "./views/ForestVision2020English";
import ForestCovertureFrench from "./views/ForestCovertureFrench";
import LeadershipSurgeNaperville from "./views/LeadershipSurgeNaperville";
import ForestJuvenilesEN from "./views/ForestJuvenilesEN";
import ForestJuvenilesFR from "./views/ForestJuvenilesFR";
import SedNursingTrainingGuide from "./views/SedNursingTrainingGuide";
import DonkeyAll from "./views/DonkeyAll";
import ForestersTemp from "./views/ForestersTemp";
import ForestersCEEN from "./views/ForestersCE-EN";
import ForestersCEFR from "./views/ForestersCE-FR";
import Libero from "./views/Libero";
import ForestersWholeFR1 from "./views/ForestersWholeFR1";
import ForestersWholeFR2 from "./views/ForestersWholeFR2";
import ForestersMasterclass1EN from "./views/ForestersMasterclass1EN";
import ForestersMasterclass1FR from "./views/ForestersMasterclass1FR";
import EQConnect_RE_Equity_Labs_Academy from "./views/EQConnect_RE_Equity_Labs_Academy.vue";
import ForestersCanadaCEEN from "./views/ForestersCanadaCE-EN";
import ForestersCanadaCEFR from "./views/ForestersCanadaCE-FR";
Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/eqconnect/RELA",
      component: EQConnect_RE_Equity_Labs_Academy,
    },
    {
      path: "/foresters/canada/ce-en",
      component: ForestersCanadaCEEN,
    },
    {
      path: "/foresters/canada/ce-fr",
      component: ForestersCanadaCEFR,
    },
    {
      path: "/foresters/ce-en",
      component: ForestersCEEN,
    },
    {
      path: "/foresters/ce-fr",
      component: ForestersCEFR,
    },
    {
      path: "/foresters/masterclass-1-en",
      component: ForestersMasterclass1EN,
    },
    {
      path: "/foresters/masterclass-1-fr",
      component: ForestersMasterclass1FR,
    },
    {
      path: "/donkey/all",
      component: DonkeyAll,
    },
    {
      path: "/sed/nursing-training-guide",
      component: SedNursingTrainingGuide,
    },
    {
      path: "/foresters/temp",
      component: ForestersTemp,
    },
    {
      path: "/foresters/whole-1-fr",
      component: ForestersWholeFR1,
    },
    {
      path: "/foresters/whole-2-fr",
      component: ForestersWholeFR2,
    },
    {
      path: "/libero",
      component: Libero,
    },
    {
      path: "/foresters/par-fr",
      component: ForestParFr,
    },
    {
      path: "/foresters/par-en",
      component: ForestParEn,
    },
    {
      path: "/foresters/sales-en",
      component: ForestersSalesEN,
    },
    {
      path: "/foresters/sales-fr",
      component: ForestersSalesFR,
    },
    {
      path: "/foresters/vision-fr",
      component: ForestVision2020French,
    },
    {
      path: "/foresters/vision-en",
      component: ForestVision2020English,
    },
    {
      path: "/foresters/juveniles-en",
      component: ForestJuvenilesEN,
    },
    {
      path: "/foresters/juveniles-fr",
      component: ForestJuvenilesFR,
    },
    {
      path: "/wellbeing/1",
      component: Wellbeing1,
    },
    {
      path: "/leadership/naperville",
      component: LeadershipSurgeNaperville,
    },
    {
      path: "/foresters/coverture-fr",
      component: ForestCovertureFrench,
    },
    {
      path: "/foresters/estate",
      component: ForestersEstate,
    },
    {
      path: "/foresters/better",
      component: ForestBetter,
    },
    {
      path: "/foresters/opportunity",
      component: ForestOpportunity,
    },
    {
      path: "/foresters/rsg",
      component: ForestRSG,
    },
    {
      path: "/foresters/3",
      component: ForestMar25,
    },
    {
      path: "/crown/1",
      component: Crown1,
    },
    {
      path: "/cf/1",
      component: Concussion1,
    },
    {
      path: "/uky/1",
      component: UKY1,
    },
    {
      path: "/crown/2",
      component: Crown2,
    },
    {
      path: "/foresters/english",
      component: Feng,
    },
    {
      path: "/foresters/advantage",
      component: Advantage,
    },
    {
      path: "/legalwise/june/nz",
      component: LegalWiseJuneNZ,
    },
    {
      path: "/legalwise/june/aus",
      component: LegalWiseJuneAUS,
    },
    {
      path: "/cuservices/1",
      component: Cuservices,
    },
    {
      path: "/cuservices/2",
      component: Ceu2,
    },
    {
      path: "/tmg/1",
      component: Tmg1,
    },
    {
      path: "/foresters/french",
      component: Ffre,
    },
    {
      path: "/foresters/p1",
      component: Forp1,
    },
    {
      path: "/foresters/p2",
      component: Forp2,
    },
    {
      path: "/toro/1",
      component: Vlad1,
    },
    {
      path: "/sightline/1",
      component: Truman,
    },
    {
      path: "/vlad/1",
      component: Vlad1,
    },
    {
      path: "/gribb/1",
      component: Gribb1,
    },
    {
      path: "/cedeflaw",
      component: Cedeflaw,
    },
    {
      path: "/proliteracy/1",
      component: proliteracty,
    },
    {
      path: "/mcico/1",
      component: mcico,
    },
    {
      path: "/vetvine",
      component: Vetvine,
    },
    {
      path: "/demo",
      component: Demo,
    },
    {
      path: "/cybersafe",
      component: Cybersafe,
    },
    {
      path: "/nebo/transportation",
      component: Transportation,
    },
    {
      path: "/sign-in",
      component: Signin,
      beforeEnter: requireNoAuth
    },
    {
      path: "/authenticated",
      component: Authenticated,
      beforeEnter: requireAuth
    },
    {
      path: "/sign-up",
      component: Signup,
      beforeEnter: requireNoAuth
    },
    {
      path: "/",
      component: Index
    },
    {
      path: "/sign-out",
      beforeEnter(to, from, next) {
        store.dispatch("signOut");
        next("sign-in");
      }
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

function requireAuth(to, from, next) {
  if (store.getters.isAuthenticated) {
    next();
  } else {
    next({
      path: "/sign-in",
      query: { redirect: to.fullPath }
    });
  }
}

function requireNoAuth(to, from, next) {
  if (store.getters.isAuthenticated) {
    next({ path: '/'});
  } else {
    next();
  }
}
